// Pure key-composition extracted from ChartRenderer.jsx (Fase 1 P1, bloco
// render-core). The ChartCanvas React `key` was an inline template literal;
// moved here so the remount-trigger composition can be unit-tested directly.
// ChartRenderer delegates — the produced string is identical.
//
// Serves Directive 8: hash Renko/P&F muda → remount; resetKey (troca de
// símbolo) muda → remount. The key is the single lever that forces a full
// ChartCanvas remount (canvas-based component does not re-render from props
// alone), so any change to these inputs MUST change the key.
export function buildChartKey({
  chartId,
  resetKey,
  renkoConfigHash,
  pointFigureConfigHash,
  isCompareMode,
}) {
  return `chart-${chartId}-${resetKey}-${renkoConfigHash || ""}-${pointFigureConfigHash || ""}-compare-${isCompareMode}`;
}
